<div class="flex flex-col gap-2">
  <span>
    {{ label }}
    @if (tooltip) {
      <mat-icon [matTooltip]="tooltip">info</mat-icon>
    }
  </span>
  <mat-form-field class="flex-1" [subscriptSizing]="subscriptSizing">
    <input
      matInput
      [placeholder]="placeholder"
      [disabled]="disabled$ | async"
      [formControl]="formCtrl"
    />

    <mat-hint><ng-content select="mat-hint" /></mat-hint>
    @if (formCtrl.invalid && formCtrl.touched && errorMessage) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
  </mat-form-field>
</div>
